// extracted by mini-css-extract-plugin
module.exports = {"contents":"DocsCard_contents__7rjjn"};